var React = require('react');

function TickIconLightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.8714 1.71433L11.4225 0.139763C11.251 -0.0465878 10.9729 -0.0465878 10.8014 0.139763L4.76567 6.69883L2.19851 3.90921C2.02709 3.72286 1.749 3.72286 1.57754 3.90921L0.128614 5.48378C-0.0428714 5.67009 -0.0428714 5.97226 0.128614 6.15861L4.4552 10.8602C4.54094 10.9534 4.65333 11 4.7657 11C4.87809 11 4.99049 10.9534 5.0762 10.8602L12.8714 2.38913C12.9538 2.29966 13 2.17827 13 2.05175C13 1.92516 12.9538 1.80384 12.8714 1.71433Z","fill":"current"}));
}

TickIconLightInline.defaultProps = {"width":"13","height":"11","viewBox":"0 0 13 11","fill":"none"};

module.exports = TickIconLightInline;

TickIconLightInline.default = TickIconLightInline;
